import React from "react";

export const AICategorisedAccepted = ({ size = "24" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.0001" cy="12" r="10" fill="#9254E5" fill-opacity="0.5" />
      <circle
        cx="12.0001"
        cy="12"
        r="10"
        fill="url(#paint0_linear_6844_3658)"
      />
      <path
        d="M15.7614 11.3592C13.574 10.549 12.0419 9.29272 11.3075 6.5353C10.4567 9.22217 9.28033 10.3104 6.71537 11.1943C8.94437 11.7846 10.3454 13.1301 11.1453 15.8429C11.6206 13.0284 13.1278 12.0024 15.7614 11.3592Z"
        fill="white"
      />
      <path
        d="M17.6877 15.847C16.6701 15.545 15.9367 15.0207 15.5205 13.7907C15.2148 15.0365 14.7133 15.5662 13.5751 16.0449C14.605 16.2457 15.2816 16.8145 15.7262 18.0222C15.8576 16.7298 16.5112 16.2185 17.6877 15.847Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6844_3658"
          x1="12.0518"
          y1="2"
          x2="22.8269"
          y2="8.62105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B29BFF" />
          <stop offset="1" stop-color="#8064DE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
